<template>
  <transition name="fade" >
  <div
    v-if="showData.name"
    :class="{
      mask: noMask,
      transparent: !showData.mask,
    }"
  >
    <Tip
      v-if="showData.name === 'tip'"
      :popupData="showData.data"
    />
    <Loading
      v-if="showData.name === 'loading'"
      :popupData="showData.data"
    />
    <FbbDialog
      v-if="showData.name === 'fbbDialog'"
      :popupData="showData.data"
    />
  </div>
  </transition>
</template>

<script>
import Tip from './Tip';
import Loading from './Loading';
import FbbDialog from './FbbDialog';

export default {
  name: 'Popup',
  data() {
    return {
      showData: {
        name: '',
        data: {},
        mask: true,
      },
      initData: {
        name: '',
        data: {},
        mask: true,
      },
      tipDelay: 1.5,
      noMask: true,
    };
  },
  components: {
    Tip,
    Loading,
    FbbDialog,
  },
  mounted() {
    this.$bus.$on('showPopup', (emitData) => {
      clearTimeout(this.timer);
      this.showData = emitData;
      if (emitData.name === 'tip') {
        this.tipDelay = emitData.data && emitData.data.length > 15 ? 3 : 1.5;
        this.showData.mask = false;
        // this.noMask = false;
        this.timer = setTimeout(() => {
          this.hidePopup();
        }, this.tipDelay * 1000);
      } else {
        this.showData.mask = true;
      }
    });
    this.$bus.$on('hidePopup', () => {
      this.showData = this.initData;
    });
  },
  methods: {
    hidePopup() {
      this.$bus.$emit('hidePopup');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/Popup.vue